import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { Typo, TypoCaption } from "@ui/text/Typo";
import { useState } from "react";
import { GD } from "src/GD";
import { useMobile } from "src/hooks/useMobile";
import { FormParser } from "../FormParser";
import { StartScreenView } from "../StartScreenView";
import { S_AUTH_CHANGE_VIEW } from "./AuthSignals";

const getForm = () => {
	const form = {
		email: "",
	};
	return form;
};

export const ForgotPassword = () => {
	useLocale();
	const [busy, setBusy] = useState(false);
	const [completed, setCompleted] = useState<boolean>();
	const { isMobile, isTablet } = useMobile();

	return (
		<StartScreenView busy={busy}>
			<Box
				sx={{
					width: isMobile ? "100%" : undefined,
					overflow: isMobile ? "auto" : undefined,
					display: "flex",
					height: "100%",
					minHeight: isMobile ? undefined : "700px",
					borderStartStartRadius: isMobile ? "0" : "12px",
					borderEndStartRadius: isMobile ? "0" : "12px",
					borderEndEndRadius: isTablet ? "12px" : "0",
					borderStartEndRadius: isTablet ? "12px" : "0",
					backgroundColor: "rgba(255,255,255,1)",
				}}>
				<Box
					sx={{
						padding: isMobile ? "34px 26px" : "60px",
						minWidth: isMobile ? "0" : "500px",
						width: isMobile ? "100%" : "auto",
						display: "flex",
						margin: isMobile ? "auto" : undefined,
						maxWidth: isMobile ? "500px" : undefined,
						flexDirection: "column",
					}}>
					{!completed && (
						<Typo capitalize sx={{ fontSize: "26px", fontWeight: 400 }}>{msg("forgotPassword_30c1d8d3")}<br />{msg("pleaseEnterYour")}<br />{msg("emailToRestore")}</Typo>
					)}

					{completed && (
						<Typo capitalize sx={{ fontSize: "26px", fontWeight: 400 }}>{msg("almostDone")}<br />{msg("pleaseCheckYour")}<br />{msg("emailAddress")}</Typo>
					)}

					{/* <Typo>Use your credential to log in</Typo> */}
					<Spacer size="40px" />

					{!completed && (
						<>
							<FormParser
								key={"restoreForm"}
								ignoreObserver={true}
								secondaryButton={null}
								fullSizeButtons={true}
								primaryButton={{ title: msg("resetPassword"), variant: "primary", sx: { flexGrow: "1" } }}
								onSubmit={async (data: any): Promise<any> => {
									setBusy(true);
									const response = await GD.REQ_API.request({
										method: "auth/forgot",
										data: data,
									});
									setBusy(false);
									if (response.error) return { data: data, error: response.error };
									if (response.data && response.data === true) {
										// todo - Show Verification CODE
										setCompleted(true);
									}
									return { data };
								}}
								onRequest={async (): Promise<any> => {
									return getForm();
								}}
							/>

							<Box
								sx={{
									display: "flex",
									gap: "5px",
									alignItems: "center",
									margin: "25px 0",
								}}>
								<Box
									sx={{
										border: "1px solid rgba(0,0,0,0.14)",
										width: "100%",
									}}
								/>
								<TypoCaption italic>{msg("or")}</TypoCaption>
								<Box
									sx={{
										border: "1px solid rgba(0,0,0,0.14)",
										width: "100%",
									}}
								/>
							</Box>
						</>
					)}

					{completed && (
						<>
							<Typo sx={{ maxWidth: "370px" }}>{msg("ifWeFoundYourEmailAddressInOurSystemWeVeJustSentYouThePasswo_5ee29dc4")}</Typo>
							<Spacer size="20px" />
						</>
					)}

					<Button
						sx={{
							width: "auto",
						}}
						variant={completed ? "primary" : "secondary"}
						onClick={() => S_AUTH_CHANGE_VIEW.invoke("login")}>
						{completed ? msg("back") : msg("signIn")}
					</Button>
				</Box>
			</Box>
		</StartScreenView>
	);
};
